import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { getCache, setCache } from '../utils/cache';
import RenderMonitor from '../components/RenderMonitor';

function InactiveTeams() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError('');
      const CACHE_KEY = `client.${id}.inactiveTeams.v1`;
      const cached = getCache(CACHE_KEY, 2 * 60 * 1000);
      if (cached) {
        const data = cached.data || cached;
        const cachedTeams = Array.isArray(data.teams) ? data.teams : (cached.teams || []);
        setClientName(data.clientName || '');
        setTeams(cachedTeams);
        setLoading(false);
        // Background refresh to ensure completeness if cache was partial
        console.log('[INACTIVE][DB] REFRESH inactive teams');
        const { data: freshTeams } = await supabase.from('teams').select('id, name').eq('client_id', id).eq('active', false);
        if (Array.isArray(freshTeams)) {
          setTeams(freshTeams);
          setCache(CACHE_KEY, { clientName: data.clientName || '', teams: freshTeams });
        }
        return;
      }
      console.log('[INACTIVE][DB] SELECT client name & inactive teams');
      const [{ data: clientData }, { data, error }] = await Promise.all([
        supabase.from('clients').select('business_name').eq('id', id).single(),
        supabase.from('teams').select('id, name').eq('client_id', id).eq('active', false)
      ]);
      if (clientData && clientData.business_name) setClientName(clientData.business_name);
      if (error) {
        setError('Could not fetch inactive teams');
        setLoading(false);
        return;
      }
      setTeams(data || []);
      setCache(CACHE_KEY, { clientName: clientData?.business_name || '', teams: data || [] });
      setLoading(false);
    };
    fetchData();
  }, [id]);

  return (
    <div className="modern-container-narrow">
      <RenderMonitor componentName="InactiveTeams" />
      <button onClick={() => navigate(-1)} className="modern-button modern-button-secondary modern-mb-6">
        ← Back
      </button>
      <div className="modern-card">
        <h1 className="modern-title">Inactive Teams for {clientName || 'Client'}</h1>
        {loading ? (
          <div className="modern-loading">Loading inactive teams...</div>
        ) : error ? (
          <div className="modern-error">{error}</div>
        ) : teams.length === 0 ? (
          <p style={{ color: '#64748b', fontStyle: 'italic' }}>No inactive teams.</p>
        ) : (
          <div className="modern-flex modern-flex-col modern-gap-6">
            {teams.map(team => (
              <div key={team.id} className="modern-card">
                <div className="modern-flex modern-justify-between modern-items-center">
                  <h3 className="modern-heading">{team.name || 'Untitled Team'}</h3>
                  <button className="modern-button modern-button-info" onClick={() => navigate(`/team/${team.id}/bootcamps`)}>
                    History
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InactiveTeams; 